import { useState } from 'react';
import { Card, CardContent } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { Camera, Image, Film, Heart } from 'lucide-react';

export default function Memories() {
  return (
    <div className="space-y-8 pb-20 md:pb-8">
      {/* Header */}
      <div className="space-y-4">
        <h1 className="text-4xl md:text-5xl font-heading font-bold tracking-tight">
          Memories
        </h1>
        <p className="text-lg text-gray-400">
          Capture and share your event experiences
        </p>
      </div>

      {/* Coming Soon */}
      <Card className="glass border-white/10 p-12 text-center">
        <Camera className="h-16 w-16 text-primary mx-auto mb-4" />
        <h3 className="text-2xl font-heading font-bold mb-2">Memories Coming Soon</h3>
        <p className="text-gray-400 mb-6">
          Share photos, videos, and moments from your favorite events
        </p>
        <div className="flex flex-wrap justify-center gap-4">
          <Button variant="outline" className="glass-hover">
            <Image className="h-4 w-4 mr-2" />
            Upload Photo
          </Button>
          <Button variant="outline" className="glass-hover">
            <Film className="h-4 w-4 mr-2" />
            Upload Video
          </Button>
        </div>
      </Card>

      {/* Features Preview */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        <Card className="glass border-white/10">
          <CardContent className="p-6 text-center space-y-3">
            <Image className="h-12 w-12 text-primary mx-auto" />
            <h3 className="font-heading font-bold">Photo Galleries</h3>
            <p className="text-sm text-gray-400">
              Share your best event photos with the community
            </p>
          </CardContent>
        </Card>

        <Card className="glass border-white/10">
          <CardContent className="p-6 text-center space-y-3">
            <Film className="h-12 w-12 text-secondary mx-auto" />
            <h3 className="font-heading font-bold">Video Moments</h3>
            <p className="text-sm text-gray-400">
              Capture and relive your favorite performances
            </p>
          </CardContent>
        </Card>

        <Card className="glass border-white/10">
          <CardContent className="p-6 text-center space-y-3">
            <Heart className="h-12 w-12 text-accent-cyan mx-auto" />
            <h3 className="font-heading font-bold">Event Timeline</h3>
            <p className="text-sm text-gray-400">
              View all memories from events you've attended
            </p>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
